import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../lib/cart";
import { fmtUSD } from "../lib/api";
import { Minus, Plus, X, ArrowRight } from "lucide-react";

export default function CartPage() {
    const { items, updateQty, removeItem, subtotal } = useCart();
    const navigate = useNavigate();

    return (
        <div data-testid="cart-page" className="pt-48 pb-24 bg-[var(--bg)] min-h-screen">
            <div className="max-w-6xl mx-auto px-6 lg:px-10">
                <div className="mb-10">
                    <div className="data-label mb-3 text-brand">RESEARCH ORDER</div>
                    <h1 className="font-serif text-5xl md:text-6xl">Your Cart</h1>
                </div>

                {items.length === 0 ? (
                    <div className="card p-12 text-center">
                        <p className="text-secondary mb-6">No compounds in your research order.</p>
                        <Link to="/shop" className="btn btn-gold">Browse Catalog</Link>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
                        <div className="lg:col-span-8 space-y-3">
                            {items.map((it) => {
                                const disc = it.quantity >= 3 ? 5.3 : it.quantity === 2 ? 3.6 : 0;
                                const lineTotal = it.price * it.quantity * (1 - disc / 100);
                                return (
                                    <div key={it.id} className="card p-4 flex gap-4" data-testid={`cart-item-${it.slug}`}>
                                        <img src={it.image} alt={it.name} className="w-24 h-24 object-cover bg-[var(--bg)]" />
                                        <div className="flex-1">
                                            <Link to={`/product/${it.slug}`} className="font-serif text-xl hover:text-brand">{it.name}</Link>
                                            <div className="data-label mt-1">{it.strength}</div>
                                            {disc > 0 && <div className="pill pill-gold mt-2">−{disc}% BULK SAVINGS</div>}
                                        </div>
                                        <div className="flex flex-col items-end justify-between">
                                            <button onClick={() => removeItem(it.id)} className="btn btn-ghost p-1" data-testid={`remove-${it.slug}`}>
                                                <X size={14} />
                                            </button>
                                            <div className="flex items-center border border-[var(--border)]">
                                                <button onClick={() => updateQty(it.id, it.quantity - 1)} className="px-2 py-1"><Minus size={10} /></button>
                                                <span className="font-mono text-xs px-3">{it.quantity}</span>
                                                <button onClick={() => updateQty(it.id, it.quantity + 1)} className="px-2 py-1"><Plus size={10} /></button>
                                            </div>
                                            <div className="font-mono text-brand">{fmtUSD(lineTotal)}</div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <div className="lg:col-span-4">
                            <div className="card p-6 lg:sticky lg:top-32 space-y-4">
                                <div className="data-label text-brand">ORDER SUMMARY</div>
                                <div className="flex justify-between font-mono text-sm">
                                    <span className="text-muted">Subtotal (after bulk savings)</span>
                                    <span className="text-primary">{fmtUSD(subtotal)}</span>
                                </div>
                                <div className="hairline" />
                                <div className="flex justify-between">
                                    <span className="data-label">Total Estimate</span>
                                    <span className="font-serif text-2xl text-brand">{fmtUSD(subtotal)}</span>
                                </div>
                                <p className="data-label text-[0.6rem] text-muted">Shipping and final coupon discount calculated at checkout.</p>
                                <button onClick={() => navigate("/checkout")} data-testid="checkout-btn" className="btn btn-gold w-full">
                                    Proceed to Checkout <ArrowRight size={14} />
                                </button>
                                <Link to="/shop" className="block text-center data-label hover:text-brand">← Continue Browsing</Link>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
